import { render, staticRenderFns } from "./AccountFrozenModal.vue?vue&type=template&id=3342071b&scoped=true"
import script from "./AccountFrozenModal.vue?vue&type=script&lang=js"
export * from "./AccountFrozenModal.vue?vue&type=script&lang=js"
import style0 from "./AccountFrozenModal.vue?vue&type=style&index=0&id=3342071b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3342071b",
  null
  
)

export default component.exports